import React from 'react';
import { Appointment } from '../../../../types/appointments';
import { BookAppointmentWithPatient } from '../bookWithPatient/BookAppointmentWithPatient';
import { BookAppointmentNoPatient } from '../bookNoPatient/BookAppointmentNoPatient';
import { UserData } from '../../../../types/users';

interface IAppointmentSlotCardProps {
  closeForm: (keepPatient: boolean) => void;
  selectedSlotAppointments: Appointment[];
  selectedPatient?: UserData;
}

export const BookAppointmentSlotCard = ({
  closeForm,
  selectedSlotAppointments,
  selectedPatient,
}: IAppointmentSlotCardProps) => {
  return (
    <>
      {selectedPatient ? (
        <BookAppointmentWithPatient
          closeForm={closeForm}
          selectedSlotAppointments={selectedSlotAppointments}
          selectedUser={selectedPatient}
        />
      ) : (
        <BookAppointmentNoPatient
          selectedSlotAppointments={selectedSlotAppointments}
          closeForm={() => closeForm(false)}
        />
      )}
    </>
  );
};
